import { ScopeContext } from '#pplx/frontend/framework/instrumentation/internal/ScopeContext.js';
import { useContext } from 'react';
/**
 * Reads the current `<InstrumentationScope>` chain at the call site and
 * returns the leaf `ScopeNode` (or `null` if no scope is mounted).
 *
 * Public alias around `useContext(ScopeContext)` so consumers — including
 * cross-package wrappers like `aether/modals`'s scope-inheritance launcher —
 * don't have to reach into `framework/instrumentation/internal/`.
 *
 * Typical use is to capture the chain during a caller's render so it can be
 * transplanted into a different React tree position via
 * `<InstrumentationInheritedScope parent={…}>`.
 */
export function useInstrumentationParentScope() {
    return useContext(ScopeContext);
}
//# sourceMappingURL=useInstrumentationParentScope.js.map